var exports = {
  "kL": "ChannelWebhooksTab.module__container___dEJUc1",
  "wx": "ChannelWebhooksTab.module__header___dEJUc1",
  "h_": "ChannelWebhooksTab.module__description___dEJUc1",
  "UD": "ChannelWebhooksTab.module__buttonContainer___dEJUc1",
  "dc": "ChannelWebhooksTab.module__spinnerContainer___dEJUc1",
  "Xb": "ChannelWebhooksTab.module__messageBox___dEJUc1",
  "PQ": "ChannelWebhooksTab.module__webhooksList___dEJUc1",
};

module.exports = exports;
